import React from 'react';
import PageHero from 'components/PageHero';

let JobOffer = () => {

    return (
        <>
            <PageHero
                eyebrow="Lavora con noi"
                title="Candidati"
                lead="Invia il tuo curriculum a jobs@studiocassolato.it"
            />
            <div className="jobs-section">
                <div className="container">
                    <div className="contact-form-block">
                        <p>Invia il tuo curriculum a jobs@studiocassolato.it; se hai un GitHub personale ci fa piacere se lo includi nel tuo messaggio.</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default JobOffer;
